const MOBILE_QUERY = '(max-width: 749px)';

const SECTION_TITLE_PATTERNS = [
  /^產品重點$/,
  /^主要規格$/,
  /^適合使用場景$/,
  /^購買前留意$/,
  /^產品介紹$/,
  /^Highlights$/i,
  /^Product highlights$/i,
  /^Key specifications$/i,
  /^Main specifications$/i,
  /^Specifications$/i,
  /^Best for$/i,
  /^Use cases$/i,
  /^Before you buy$/i,
  /^What to check$/i,
  /^Overview$/i,
];

const mobileQuery = window.matchMedia(MOBILE_QUERY);
const originalHtmlByRoot = new WeakMap();

function normalizeText(value) {
  return String(value || '')
    .replace(/\s+/g, ' ')
    .replace(/[：:]\s*$/, '')
    .trim();
}

function isElement(node) {
  return node instanceof HTMLElement;
}

function isMeaningfulNode(node) {
  if (node.nodeType === Node.TEXT_NODE) return node.textContent.trim().length > 0;
  return isElement(node);
}

function getSectionTitle(node) {
  if (!isElement(node)) return '';

  const tagName = node.tagName.toLowerCase();
  if (/^h[2-6]$/.test(tagName)) return normalizeText(node.textContent);

  if (tagName !== 'p') return '';

  const strong = node.querySelector(':scope > strong, :scope > b');
  if (!strong) return '';

  const fullText = normalizeText(node.textContent);
  const strongText = normalizeText(strong.textContent);

  return fullText === strongText ? strongText : '';
}

function isSectionTitle(title) {
  return SECTION_TITLE_PATTERNS.some((pattern) => pattern.test(title));
}

function hasVisibleContent(nodes) {
  return nodes.some((node) => normalizeText(node.textContent).length > 0);
}

function groupDescriptionContent(source) {
  const nodes = Array.from(source.childNodes).filter(isMeaningfulNode);
  const intro = [];
  const sections = [];
  let currentSection = null;

  nodes.forEach((node) => {
    const title = getSectionTitle(node);

    if (title && isSectionTitle(title)) {
      currentSection = { title, nodes: [] };
      sections.push(currentSection);
      return;
    }

    if (currentSection) {
      currentSection.nodes.push(node.cloneNode(true));
    } else {
      intro.push(node.cloneNode(true));
    }
  });

  return {
    intro,
    sections: sections.filter((section) => hasVisibleContent(section.nodes)),
  };
}

function createContentContainer(className, nodes) {
  const container = document.createElement('div');
  container.className = className;
  nodes.forEach((node) => container.appendChild(node));
  return container;
}

function buildAccordion({ intro, sections }) {
  const fragment = document.createDocumentFragment();

  if (intro.length > 0) {
    fragment.appendChild(createContentContainer('product-description-mobile-accordion__intro', intro));
  }

  const list = document.createElement('div');
  list.className = 'product-description-mobile-accordion__list';

  sections.forEach((section) => {
    const details = document.createElement('details');
    details.className = 'product-description-mobile-accordion__item';

    const summary = document.createElement('summary');
    const label = document.createElement('span');
    label.textContent = section.title;
    summary.appendChild(label);

    details.appendChild(summary);
    details.appendChild(createContentContainer('product-description-mobile-accordion__body', section.nodes));
    list.appendChild(details);
  });

  fragment.appendChild(list);
  return fragment;
}

function enhance(root) {
  const source = root.querySelector('.product-description__source');
  if (!source || root.classList.contains('is-enhanced')) return;

  originalHtmlByRoot.set(root, source.innerHTML);

  const groupedContent = groupDescriptionContent(source);
  if (groupedContent.sections.length < 2) {
    originalHtmlByRoot.delete(root);
    return;
  }

  source.replaceChildren(buildAccordion(groupedContent));
  root.classList.add('is-enhanced');
}

function restore(root) {
  const source = root.querySelector('.product-description__source');
  if (!source || !root.classList.contains('is-enhanced')) return;

  source.innerHTML = originalHtmlByRoot.get(root) || '';
  originalHtmlByRoot.delete(root);
  root.classList.remove('is-enhanced');
}

function syncRoot(root) {
  if (mobileQuery.matches) {
    enhance(root);
  } else {
    restore(root);
  }
}

function syncAll() {
  document.querySelectorAll('[data-product-description-mobile-accordion]').forEach(syncRoot);
}

mobileQuery.addEventListener('change', syncAll);
document.addEventListener('DOMContentLoaded', syncAll);
document.addEventListener('shopify:section:load', syncAll);
syncAll();
